import React from "react";

export default function SQLServer_STR() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_STR</h1>
      <p>This is the SQLServer_STR component generated from the SQL JSON.</p>
    </div>
  );
}
